<div class="pageContainer">
  <div class="contentContainer container-fix-width">
    <h2 class="title">
      {{ 'newRequestTitle' | i18next: { type: translateOrderType() } }}
    </h2>
    <div
      class="d-flex flex-column w-100 align-items-center justify-content-center gap-2"
      style="height: 87% !important"
    >
      <h3 class="text-center">{{ 'newRequestOk' | i18next }}</h3>
      <p class="text-md">{{ 'newRequestInfo' | i18next }}</p>
      <img
        src="../../../assets/icons/request_ok.svg"
        alt="request"
        style="width: 250px; margin: 100px"
      />
      <p *ngIf="substitutionRequestNumber" class="text-sm">
        {{ 'newRequestBook' | i18next }}
      </p>
      <button
        *ngIf="!substitutionRequestNumber"
        type="button"
        class="btn btn-end"
        [routerLink]="['/landing-leasing']"
      >
        {{ 'btnEndProcess' | i18next | uppercase }}
      </button>
      <div
        *ngIf="substitutionRequestNumber"
        class="d-flex flex-row gap-4 align-items-center justify-content-center"
      >
        <button
          type="button"
          class="btn btn-end"
          [routerLink]="['/book-vehicle', substitutionRequestNumber]"
        >
          {{ 'bookTitle' | i18next | uppercase }}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          [routerLink]="['/landing-leasing']"
        >
          {{ 'btnEndProcess' | i18next | uppercase }}
        </button>
      </div>
    </div>
  </div>
</div>
